import { motion } from "framer-motion";
import { OWNER, CONTACT } from "../../data";
import { Reveal } from "./Reveal";

export const Owner = () => (
  <section id="owner" data-testid="owner-section" className="relative py-24 md:py-32 bg-[#0a192f] border-y border-[#bf953f]/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <Reveal className="lg:col-span-5">
        <div className="relative mx-auto max-w-sm lg:max-w-none">
          <div className="absolute -inset-3 rounded-2xl border border-[#bf953f]/25" />
          <div className="relative overflow-hidden rounded-2xl">
            <motion.img
              initial={{ scale: 1.12 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
              src={OWNER.photo}
              alt={OWNER.name}
              className="w-full object-cover aspect-[4/5]"
              data-testid="owner-photo"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a192f] via-transparent to-transparent" />
          </div>
        </div>
      </Reveal>

      <div className="lg:col-span-7">
        <Reveal>
          <p className="font-body text-xs md:text-sm tracking-[0.3em] uppercase text-[#d4af37]">Meet the Owner</p>
          <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl md:text-6xl font-medium tracking-tight text-white" data-testid="owner-name">
            {OWNER.name}
          </h2>
          <p className="mt-2 font-body text-base md:text-lg tracking-wide text-gold-gradient inline-block" data-testid="owner-title">
            {OWNER.title}
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-6 max-w-2xl font-body font-light text-base md:text-lg leading-relaxed text-white/65">
            {OWNER.bio}
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a
              href={CONTACT.phoneHref}
              data-testid="owner-call-btn"
              className="btn-sweep inline-flex items-center rounded-full bg-gold-metallic px-7 py-3 font-body text-sm font-medium tracking-wide text-black"
            >
              Talk to Eric
            </a>
            <a
              href={CONTACT.emailHref}
              data-testid="owner-email-btn"
              className="inline-flex items-center rounded-full border border-[#bf953f]/40 px-7 py-3 font-body text-sm tracking-wide text-white/80 hover:text-[#fcf6ba] hover:border-[#d4af37] transition-colors duration-300"
            >
              Email the Agency
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
